export default __webpack_public_path__ + "static/media/btn-info.efb85ff0.svg";